import EusButton                  from 'components/Button/EusButton'
import { Box as FloatPopup } from '@mui/material';
import EventInfo                  from './EventInfo/EventInfo';
import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';

const OpenHouseEventInfoPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  
  return (
    <FloatPopup sx = {FloatPopupCSS}>
            <EusButton
                iconName    = {"calender-check"}
                icon        = {true}
                clr         = {clr}
                buttonlabel = {false}
                otherText   = {"Ønsker du at se Travbyen?"}
                onClick     = {() => { setShowPopup(true) }}
                variant     = {"primary"}
                iconSize    = {"xl"}
                width       = {"max-content"}
                isFaIcon    = {true}
                padding     = {"15px 30px"}
            />

        <AnimatePresence>
          { showPopup && <EventInfo setShowPopup={setShowPopup} /> }
        </AnimatePresence>
    </FloatPopup>
  )
}

export default OpenHouseEventInfoPopup



const FloatPopupCSS = {
    position: 'absolute',
    top     : '24px',
    left    : '24px',
    zIndex  : 1,
    width   : '100%',
}